import script from "./WeeklyTillsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WeeklyTillsCard.vue?vue&type=script&setup=true&lang=js"

import "./WeeklyTillsCard.vue?vue&type=style&index=0&id=71a91d69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a91d69"]])

export default __exports__